// extracted by mini-css-extract-plugin
module.exports = {"card":"CreateNew_card__gOt80"};